import { FC } from "react";

import { formatDispenseData } from "src/helpers/dateTime";
import { RefillDataListing } from "src/pages/globalPatient/types";
import { REFILL_DATA_LISTING } from "src/types/case";


const RefillData: FC<{refill_data:RefillDataListing[]}> = ({refill_data}): JSX.Element => {
  return (
    <div className="card my-3">
      <div className="card-header">
        <h4 className="mb-0">Pharmacy Refill Shipments</h4>
      </div>

      <div className="card-body p-0">
        <div
          className="table-responsive"
          style={refill_data && refill_data.length > 10 ? { maxHeight: 450, overflowY: "auto" } : undefined}
        >
          <table className="table table-striped table-hover">
            <thead className="sticky-top">
              <tr className="text-center">
                {REFILL_DATA_LISTING.map((head, index) => (
                  <th key={index}>{head.label}</th>
                ))}
              </tr>
            </thead>

            <tbody>
              {refill_data && refill_data.length > 0 ? (
                refill_data.map((row, index) => (
                  <tr className="text-center" key={index}>
                    <td>{formatDispenseData(row.dispense_date)}</td>
                    <td>{row.shipment_type}</td>
                    <td>{row.prescriber_lastname}</td>
                    <td>{row.prescriber_firstname}</td>
                    <td>{row.rx_qty}</td>
                    <td>{row.refill}</td>
                    <td>{row.patient_id}</td>
                    <td>{row.fill_number}</td>
                    <td>{row.rx_number}</td>
                  </tr>
                ))
              ): null}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default RefillData;
